import { useLazyGetPlaysFiltersQuery } from '@carboncopyco/data';
import { Separator } from '@carboncopyco/ui';
import { capitalize } from '@carboncopyco/utils';
import { useEffect } from 'react';
import { SortDropdown } from '../../../UrlStateControls';
import { MultiStringFilter } from '../../Controls/MultiStringFilter';
import { usePlaybookPageProps } from '../PlaybookPageContext';
import { usePresentationsContext } from '../PresentationsContext';

type ControlsProps = { isArchive?: boolean };

export const Controls = ({ isArchive }: ControlsProps) => {
  const { organizationId, playbookId, workspaceId } = usePlaybookPageProps();
  const { urlState } = usePresentationsContext();
  const { query } = urlState;

  const [getFilters, { data: filters }] = useLazyGetPlaysFiltersQuery();

  useEffect(() => {
    getFilters({
      workspaces: [workspaceId],
      organizationId: organizationId,
      assetId: playbookId,
      assetType: 'playbook',
      deletedEntities: isArchive,
      query,
    });
  }, [workspaceId, getFilters, isArchive, organizationId, playbookId, query]);

  const creatorOptions =
    filters?.creators?.map((creator) => ({
      id: creator.userId,
      label: capitalize(creator.userName),
    })) || [];

  const companyOptions =
    filters?.companies?.map((company) => ({
      id: company,
      label: company,
    })) || [];

  return (
    <div className="flex p-4 mt-1 gap-3">
      <SortDropdown />
      <div>
        <Separator />
      </div>
      <MultiStringFilter
        capsuleWidth={192}
        placeholder="Created by"
        options={creatorOptions}
        type="creators"
      />
      <MultiStringFilter
        placeholder="Presenting to"
        capsuleWidth={192}
        options={companyOptions}
        type="companies"
      />
    </div>
  );
};
